import React from 'react';
import { FormDialog } from '../../../form-dialog';
import { Box } from '../../../box';
import { Cell } from '../../../cell';
import { Row } from '../../../row';
import { Typography } from '../../../typography/typography';
import { UserLookup } from '../../../lookups';
import { FormControl } from '../../../form-control/form-control';
import { Container } from '../../../container/container';

export class MassReassignBookingsDialogIds {
  public static Dialog = 'mass-reassign-bookings-dialog';
  public static BookingCount = 'mass-reassign-bookings-dialog-booking-count';
}

export interface IMassReassignBookingsDialogComponentProps {
  bookingCount: number;
  newCaseworkerId?: string;
  isLoading: boolean;
  isOpen: boolean;
  onCaseworkerChange: (userId: string | undefined) => void;
  onConfirm: () => void;
  onClose: () => void;
}

export function MassReassignBookingsDialogComponent({
  bookingCount,
  newCaseworkerId,
  isLoading,
  isOpen,
  onCaseworkerChange,
  onConfirm,
  onClose,
}: IMassReassignBookingsDialogComponentProps) {
  return (
    <FormDialog
      open={isOpen}
      title="Massetildel ansvarlig sagsbehandler"
      confirmButtonText="Udfør"
      cancelButtonText="Afbryd"
      isLoading={isLoading}
      onConfirmClick={onConfirm}
      onClose={onClose}
      onCancelClick={onClose}
      maxWidth="lg"
      isValid={!!newCaseworkerId}
    >
      <FormControl fullWidth>
        <Container>
          <Box width="500px" data-testid={MassReassignBookingsDialogIds.Dialog}>
            <Row>
              <Cell size="full">
                <Typography variant="body2" data-testid={MassReassignBookingsDialogIds.BookingCount}>
                  {bookingCount === 1 ? `${bookingCount} samtale vil blive omfordelt.` : `${bookingCount} samtaler vil blive omfordelt.`}
                </Typography>
              </Cell>
            </Row>
            <Row>
              <Cell size="full">
                <UserLookup value={newCaseworkerId} onChange={onCaseworkerChange} required />
              </Cell>
            </Row>
          </Box>
        </Container>
      </FormControl>
    </FormDialog>
  );
}
